export default __webpack_public_path__ + "static/media/screenShots_delivery-1.0aa90e28.jpg";